
import  FontFaceObserver  from 'fontfaceobserver';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';

import "./fonts/fonts.css";


import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './ie.css';



import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom'



var fontA = new FontFaceObserver('MyriadProRegular');
var fontB = new FontFaceObserver('MyriadProSemibold');
 
fontA.load().then(function () {
  console.log('Family A is available');
});
 
fontB.load().then(function () {
  console.log('Family B is available');
});



window.matchMedia = window.matchMedia || (() => { return { matches: false, addListener: () => {}, removeListener: () => {}, }; });
// const browserHistory = {};
const basename = "/";
// const basename = "/go-israel-new/";
// const basename = "/";
ReactDOM.render(
	<BrowserRouter basename={basename}   forceRefresh={true} >
		
		<App />
	</BrowserRouter>
	, document.getElementById('root'));
// registerServiceWorker();





// WEBPACK FOOTER //
// ./src/index.js